/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { PlaceholderGenerator } from "../PlaceholderGenerator";
import { PlaceholderUtils } from "./PlaceholderUtils";
var getPlaceholderData = function (placeholders, predefinedPlaceholder, targetAudience) {
    var _a, _b, _c;
    var predefinedPlaceholderClone = JSON.parse(JSON.stringify(predefinedPlaceholder.placeholderdescriptor));
    delete predefinedPlaceholderClone.alternateBindings;
    predefinedPlaceholderClone.binding = (_a = targetAudience === null || targetAudience === void 0 ? void 0 : targetAudience.binding) !== null && _a !== void 0 ? _a : (_c = (_b = predefinedPlaceholder.placeholderdescriptor) === null || _b === void 0 ? void 0 : _b.alternateBindings) === null || _c === void 0 ? void 0 : _c[0].binding;
    var predefinedPlaceholderData = predefinedPlaceholderClone;
    if (!predefinedPlaceholderData) {
        predefinedPlaceholderData = PlaceholderGenerator.generateEmptyPlaceholder({
            title: predefinedPlaceholder.label,
            placeholderCategory: predefinedPlaceholder.category
        });
    }
    predefinedPlaceholderData.predefinedPlaceholderId = predefinedPlaceholder.id;
    var existingPlaceholderName = Object.keys(placeholders !== null && placeholders !== void 0 ? placeholders : {})
        .find(function (name) { var _a; return ((_a = placeholders[name]) === null || _a === void 0 ? void 0 : _a.predefinedPlaceholderId) === predefinedPlaceholder.id; });
    if (existingPlaceholderName) {
        return {
            placeholderName: existingPlaceholderName,
            placeholder: placeholders[existingPlaceholderName]
        };
    }
    existingPlaceholderName = Object.keys(placeholders !== null && placeholders !== void 0 ? placeholders : {})
        .find(function (name) { return name === predefinedPlaceholder.label; });
    if (existingPlaceholderName) {
        var generatedPlaceholderName = PlaceholderUtils.generatePlaceholderNameFromTemplate(function (number) { return "".concat(existingPlaceholderName).concat(number); }, placeholders);
        return {
            placeholderName: generatedPlaceholderName,
            placeholder: __assign(__assign({}, predefinedPlaceholderData), { title: generatedPlaceholderName })
        };
    }
    return {
        placeholderName: predefinedPlaceholder.label,
        placeholder: predefinedPlaceholderData
    };
};
var removeIdReferencesOnPlaceholderLabelChange = function (definedPlaceholders, newPlaceholderName, placeholderId) {
    var definedPlaceholdersCopy = JSON.parse(JSON.stringify(definedPlaceholders));
    Object.entries(definedPlaceholdersCopy).forEach(function (_a) {
        var _b = __read(_a, 2), k = _b[0], p = _b[1];
        if (p.predefinedPlaceholderId === placeholderId && k !== newPlaceholderName) {
            p.predefinedPlaceholderId = null;
        }
    });
    return definedPlaceholdersCopy;
};
export var PredefinedPlaceholderUtils = {
    getPlaceholderData: getPlaceholderData,
    removeIdReferencesOnPlaceholderLabelChange: removeIdReferencesOnPlaceholderLabelChange
};
